const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL || "https://aclbqa.sisamlat.com/api";

const SANCTUM_CSRF_URL =
    process.env.REACT_APP_SANCTUM_CSRF_URL ||
    "https://aclbqa.sisamlat.com/sanctum/csrf-cookie";

export { API_BASE_URL, SANCTUM_CSRF_URL };
